import { createContext } from 'react';

const ThemeContext = createContext<{
  theme: Theme;
}>(undefined);

export default ThemeContext;
